var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contact-view"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"calendly-inline-widget",attrs:{"data-url":"https://calendly.com/hello-hgy/introductory-call"}})])])
}]

export { render, staticRenderFns }